import { Button } from '@sunwebgroup/uds-ui/button'
import { useIntl } from '@/intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { useUserReviews } from '@/scopes/products/user-reviews/hooks'
import { createUserReviewsEvent } from '@/scopes/products/user-reviews/infrastructure/analytics'
import styles from './ShowMoreReviewsButton.module.css'

export function ShowMoreReviewsButton() {
  const { showNextReviews, reviewPages } = useUserReviews()
  const { sendEvent } = useAnalytics()
  const intl = useIntl()

  const handleClick = async () => {
    await showNextReviews()
    sendEvent(
      createUserReviewsEvent({
        description: 'show more reviews',
        element: 'Button',
        result: `Many times clicked: ${reviewPages.length - 1} times`,
      }),
    )
  }

  return (
    <div className={styles.wrapper}>
      <Button variant="secondary" onClick={handleClick}>
        {intl.formatMessage({ id: 'reviews_show_more_reviews' })}
      </Button>
    </div>
  )
}
